import { colorPrimary40, colorPrimary50, colorPrimary400, colorPrimary500, colorLightBlue500, colorOrange500, colorYellow600, colorMonochromeWhite } from '../settings';

var sizes = {
  // all numbers have to be odd
  tiny: 20,
  small: 38,
  normal: 70
};

var whiteSet = {
  disc: colorPrimary400,
  glow: colorLightBlue500,
  cometStart: colorMonochromeWhite,
  cometEnd: colorPrimary400
};

var blueSet = {
  disc: colorPrimary40,
  glow: colorPrimary50,
  cometStart: colorPrimary500,
  cometEnd: colorPrimary40
};

var yellowSet = {
  disc: colorYellow600,
  glow: colorOrange500,
  cometStart: colorPrimary500,
  cometEnd: colorYellow600
};

var greenSet = {
  disc: '#66e27d',
  glow: colorMonochromeWhite,
  cometStart: colorMonochromeWhite,
  cometEnd: '#66e27d'
};

var colours = {
  blue: blueSet,
  white: whiteSet,
  yellow: yellowSet,
  green: greenSet
};

export var getPreset = function getPreset(preset, theme) {
  var presetsMap = {
    primary: (theme === 'dark' ? 'white' : 'blue') + ' small'
  };

  return presetsMap[preset] || preset;
};

export var getSpinnerProperties = function getSpinnerProperties(sizeOutfit) {
  var size = sizes[sizeOutfit];
  var borderWidth = 2;
  var padding = 10;
  var radius = size / 2 - borderWidth / 2;
  var canvasSize = size + padding * 2;
  var centerPoint = canvasSize / 2;
  var arcPath = 'M' + centerPoint + ',' + (centerPoint - radius) + ' a' + radius + ',' + radius + ' 0 0,0 ' + -radius + ',' + radius;

  return {
    size: size,
    borderWidth: borderWidth,
    padding: padding,
    radius: radius,
    canvasSize: canvasSize,
    centerPoint: centerPoint,
    arcPath: arcPath
  };
};

export var getSpinnerColors = function getSpinnerColors(colorOutfit) {
  return colours[colorOutfit];
};